import { DarkMode, LightMode } from '@mui/icons-material'
import { AppBar, Container, Link, ToggleButton, ToggleButtonGroup, Toolbar, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'



export const Appbar = ({mode}) => {
  const [clicked, setClicked] = useState('')
  const [alignment, setAlignment] = React.useState('light');

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
    if(newAlignment !== null){
      mode(newAlignment)
    }
  };

  useEffect(() => {
    setClicked('')
  }, []);

  return (
      <AppBar 
        elevation="false" 
        color="transparent"
        sx={{
          background: "rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur( 15px )",
          borderBottom: "1px solid rgba( 220, 220, 220, 0.5 )"
        }}
      >
        <Container>
          <Toolbar sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
            <Typography variant="h5" component="div" fontWeight={700}>
              David
            </Typography>
            <Box sx={{
                display:"flex",
                alignItems: "center",
                '& MuiLink-root':{
                  display:{
                    xs: "none",
                    sm: "block"
                  }
                }
            }}>
              <Box sx={{
                display: {
                  xs: "none",
                  sm: "flex"
                },
                alignItems: "center",
              }}>
                <Link 
                  href="#skills" 
                  underline="none"  
                  sx={{
                    mr:4,
                    color: "skills" === clicked? "primary":"text.secondary",
                    '&:hover': {
                      color: "primary.light"
                    } 
                  }} 
                  onClick={()=>{setClicked("skills")}}
                >
                    Skills
                </Link>
                <Link 
                  href="#about" 
                  underline="none" 
                  sx={{
                    mr: 4,
                    color: "about" === clicked? "primary":"text.secondary",
                    '&:hover': {
                      color: "primary.light"
                    }
                  }}
                  onClick={()=>{setClicked("about")}}
                >
                    About
                </Link> 
                <Link 
                  href="#contact" 
                  underline="none" 
                  sx={{
                    mr: 5,
                    color: "contact" === clicked? "primary":"text.secondary",
                    '&:hover': {
                      color: "primary.light"
                    }
                  }}
                  onClick={()=>{setClicked("contact")}}
                  >
                    Contact
                </Link>
              </Box>
              <ToggleButtonGroup
                  color="primary"
                  value={alignment}
                  exclusive
                  onChange={handleChange}
              >
                <ToggleButton value="light">
                  <LightMode />
                </ToggleButton>
                <ToggleButton value="dark">
                  <DarkMode />
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
  )
}
